// extracted by mini-css-extract-plugin
export default {"container":"notFoundPage_container__6NQhU"};